import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import SEO from '../../components/common/SEO';

const Returns = () => (
  <div className="min-h-screen flex flex-col">
    <SEO
      title="Returns & Refunds"
      description="Read Elixir's returns and refund policy for Mediterranean honey. Shop with confidence knowing your satisfaction is our priority."
      keywords="Elixir returns, honey refund policy, Mediterranean honey returns, refund policy, satisfaction guarantee"
    />
    <Header />
    <main className="flex-grow bg-white py-12 px-4 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-[#d4af37] mb-6">Returns & Refunds</h1>
      <p className="mb-4">At Elixir, we want you to be delighted with your honey. If you are not satisfied, please review our returns and refund policy below.</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Return Policy</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Returns are accepted within 14 days of delivery.</li>
        <li>Products must be unopened, unused, and in original packaging.</li>
        <li>To initiate a return, contact us at <a href="mailto:team@elixir-honey.com" className="text-[#d4af37] underline">team@elixir-honey.com</a> with your order number.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Refunds</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Refunds are processed within 5 business days after we receive and inspect your return.</li>
        <li>Shipping costs are non-refundable unless the return is due to our error.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Damaged or Incorrect Items</h2>
      <p className="mb-4">If your order arrives damaged or you receive the wrong item, please contact us immediately with photos and your order number. We will arrange a replacement or refund.</p>
      <p className="mt-4">Thank you for choosing Elixir. Your satisfaction is our top priority!</p>
    </main>
    <Footer />
  </div>
);

export default Returns; 